import { render, staticRenderFns } from "./FairPayPage.vue?vue&type=template&id=37e1523d&scoped=true"
import script from "./FairPayPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FairPayPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FairPayPage.vue?vue&type=style&index=0&id=37e1523d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1523d",
  null
  
)

export default component.exports